module.exports = __webpack_public_path__ + "static/img/11.f4052e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/11.png
// module id = 2qk5
// module chunks = 0